"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCroupierRevealCommand = void 0;
const croupier_reveal_action_1 = require("../../actions/croupier-reveal-action");
class AutoCroupierRevealCommand {
    static isCommand(command) {
        return command instanceof AutoCroupierRevealCommand;
    }
    executeCommand(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const croupierRevealAction = new croupier_reveal_action_1.CroupierRevealAction(context.playerManager.board);
            croupierRevealAction.execute();
            yield context.dealProcessor.disclosePendingCards(commandHash, existingDeal);
            croupierRevealAction.resolve();
            context.eventQueue.enqueue({
                type: "onRevealDeckCroupier",
                instant,
                payload: {
                    croupier: context.playerManager.croupier.clone(),
                    cardIndex: croupierRevealAction.cardIndex,
                },
            });
        });
    }
}
exports.AutoCroupierRevealCommand = AutoCroupierRevealCommand;
